import React from "react";

import "./DropDownButton.css";

import { MultiColumnDropdown } from "./MultiColumnDropdown";

import { IconBell, IconExternalLink } from "@tabler/icons-react";

/*
	The `whatsNewDropdownLastHashViewed` value is saved
	in localStorage in via redux-localstorage-simple, which syncs
	with the browserLocalstorage redux state.

	To make the bell ring for all users, 
	increment `currentWhatsNewDropdownVersion`
*/

const WhatsNewDropdown = ({
	whatsNewDropdownLastHashViewed,
	updateWhatsNewDropdownLastHashViewed,
	whatsNewItems,
	whatsNewItemsHash,
}) => {
	const ringBellToIndicateNewWhatsNew =
		whatsNewDropdownLastHashViewed !== whatsNewItemsHash;

	return (
		<MultiColumnDropdown
			className="WhatsNewDropdown"
			buttonVariant="filled"
			onOpen={() => {
				updateWhatsNewDropdownLastHashViewed(whatsNewItemsHash);
			}}
			buttonIcon={
				<IconBell
					size={20}
					style={{
						verticalAlign: "middle",
						animation: ringBellToIndicateNewWhatsNew
							? "ring 4s 0.7s ease-in-out infinite"
							: "none",
					}}
				/>
			}
			customColumnWidth={450}
			dropdownData={{
				title: `What's new`,
				columns: [
					{
						title: "New In LexWorkplace",
						list: whatsNewItems,
					},
				],
				listItemComponentFn: ({ item, key }) => {
					return (
						<div className="WhatsNewItem" key={key}>
							<a
								href={item.url}
								target="_blank"
								rel="noopener noreferrer"
								style={{
									display: "flex",
									gap: 8,
								}}
							>
								<div
									style={{
										whiteSpace: "normal",
									}}
								>
									{item.text}
								</div>
								<div>
									<IconExternalLink
										size={16}
										color={"var(--lxw-main-500)"}
										style={{ verticalAlign: "sub" }}
									/>
								</div>
							</a>
						</div>
					);
				},
			}}
		/>
	);
};

export default WhatsNewDropdown;
